import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@material-ui/core';

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"

import EcoleForm from '../../../components/ui/Admin/Ecoles/EcoleForm'


const NewEcole = () => {
  const navigate = useNavigate()
  const [hasChanged, setHasChanged] = useState(false)

  return (
    <>
      <Helmet>
        <title>Admin Ecoles | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            withBack="/admin/ecoles"
            title="Création d'une École"
          >
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              disabled={!hasChanged}
              onClick={() => {
                document.getElementById('hidden_form_submit').click()
              }}
            >
              Créer l'école
            </Button>
          </TopBar>


          <EcoleForm
            setHasChanged={setHasChanged}
          />

        </Box>
      </Box>
    </>
  )
};

export default NewEcole;
